<template lang="html">
  <div class="form-group" :class="{ 'has-error': !!error }">
    <v-text-field
      data-private
      autofocus
      dense
      outlined
      name="email"
      type="email"
      autocomplete="on"
      :error="isError"
      :id="id"
      :data-testid="testId"
      :placeholder="placeholder"
      :disabled="disabled"
      :label="label"
      :value="value"
      @input="$emit('input', $event)"
      @blur="$emit('focusOut')"
    />
    <p v-if="!!error" class="error-message mt-n5">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    testId: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
  },

  computed: {
    isError() {
      return this.error?.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.error-message {
  color: $color-red;
}
</style>
